import Vue from 'vue'
import App from './App.vue'
import creatRouter from './router'
import routes from './router/routes'
import store from './store'
import xss from 'xss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.xss = xss

const router = creatRouter()
router.addRoutes(routes)

NProgress.configure({ showSpinner: false })
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
